import Card from '@components/Card'
import { Button } from '@/components/ui/button'
import { useTheme } from '@components/ThemeProvider'

const NoResults = ({ openModal }) => {
  const { resolvedTheme } = useTheme()

  return (
    <Card className='flex flex-col items-center justify-center p-10'>
      <Choose>
        <When condition={resolvedTheme === 'dark'}>
          <img src='/reading-dark.svg' alt='Student reading' className='w-[100px] self-center mb-5' />
        </When>
        <Otherwise>
          <img src='/reading.svg' alt='Student reading' className='w-[100px] self-center mb-5' />
        </Otherwise>
      </Choose>

      <h4 className='text-2xl font-semibold'>No students in this classroom</h4>
      <p className='text-sm text-muted-foreground mb-5'>Add students via short code, email or import from your learning management system. </p>
      <Button variant='outline' onClick={openModal}>Add students</Button>
    </Card>
  )
}

export default NoResults
